/** Traductions UI pour le client Utopie (locale fr). */
export const FR_UI: Record<string, string> = {
  'Settings': 'Paramètres',
  'Render Settings': 'Graphismes',
  'Interface Settings': 'Interface',
  'Controls Settings': 'Contrôles',
  'Sound Settings': 'Son',
  'Advanced Settings': 'Avancé',
  'VR Settings': 'Réalité virtuelle',
  'Inventory Settings': 'Inventaire',
  'Export Settings': 'Export / import',
  'Game Menu': 'Menu de jeu',
  'Back to Game': 'Retour au jeu',
  'Options...': 'Options…',
  'Options': 'Options',
  'Game Options': 'Options de jeu',
  'Disconnect & Reset': 'Déconnexion et revenir au site',
  'Disconnect and return to site': 'Déconnexion et revenir au site',
  'Save & Quit': 'Sauvegarder et quitter',
  'Discord': 'Discord',
  'Reconnect': 'Reconnecter',
  'Render...': 'Graphismes…',
  'Interface...': 'Interface…',
  'Controls...': 'Contrôles…',
  'Sound...': 'Son…',
  'Advanced...': 'Avancé…',
  'Inventory & containers...': 'Inventaire…',
  'Export/Import...': 'Export / import…',
  'VR...': 'RV…',
  'Render Distance': 'Distance de rendu',
  'Back': 'Retour',
  'Reset App (recommended)': 'Revenir au site',
  'Revenir au site': 'Revenir au site',
  'The Minecraft server kicked you. Kick reason: ': 'Le serveur Minecraft vous a expulsé. Raison : ',
  'Serveur hors ligne': 'Serveur hors ligne',
  'Vérification du serveur…': 'Vérification du serveur…',
  'Connect': 'Connexion',
  'Save': 'Enregistrer',
  'Select value': 'Choisir une valeur',
  'The option is not available': 'Option indisponible',
  'The option requires a restart to take effect': 'Un redémarrage est nécessaire',
  'The option requires a chunks reload to take effect': 'Un rechargement des chunks est nécessaire',
  'Restart': 'Redémarrer',
  'Reload': 'Recharger',
  'I will do it later': 'Plus tard',
  'Cannot be changed during game': 'Impossible en jeu',
  'Click to capture mouse': 'Cliquer pour capturer la souris',
  'ON': 'OUI',
  'OFF': 'NON',
}

export const FR_OPTION_IDS: Record<string, string> = {
  fov: 'Champ de vision',
  gpuPreference: 'GPU préféré',
  backgroundRendering: 'FPS en arrière-plan',
  activeRenderer: 'Moteur de rendu',
  vanillaLook: 'Style vanilla',
  dayCycleAndLighting: 'Cycle jour / nuit',
  smoothLighting: 'Éclairage lisse',
  newVersionsLighting: 'Éclairage (versions récentes)',
  lowMemoryMode: 'Mode faible mémoire',
  starfieldRendering: 'Ciel étoilé',
  renderEntities: 'Entités',
  keepChunksDistance: 'Distance de chunks',
  renderEars: 'Oreilles Deadmau5',
  renderDebug: 'Debug rendu',
  rendererPerfDebugOverlay: 'Debug performances',
  disableBlockEntityTextures: 'Textures entités de bloc',
  frameLimit: 'Limite de FPS',
  volume: 'Volume',
  enableMusic: 'Musique',
  musicVolume: 'Volume musique',
  chatScale: 'Taille du chat',
  chatOpacity: 'Opacité du chat',
  mouseSensX: 'Sensibilité souris X',
  mouseSensY: 'Sensibilité souris Y',
  language: 'Langue',
  localUsername: 'Pseudo local',
}

export function applyFrenchLocale () {
  window.translateText = (text: string) => {
    if (typeof text !== 'string') return text as any
    return FR_UI[text] ?? FR_OPTION_IDS[text] ?? text
  }
}
